import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/router";
import useFirebaseNotifications from "./utilFunctions/useFirebaseNotifications";

function App() {
  console.log("build: 02-10-2026");

  const languageState = useSelector((state) => state.language);
  useFirebaseNotifications();

  useEffect(() => {
    if (languageState) {
      localStorage.setItem("language", languageState.language);
      if (languageState.language === "ar") {
        document.body.dir = "rtl";
      } else {
        document.body.dir = "ltr";
      }
    }
  }, [languageState, languageState.language]);

  return <RouterProvider router={router} />;
}

export default App;
